import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Paper,
  IconButton,
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Checkbox,
} from '@material-ui/core';
import {
  ExpandMore,
  SelectAll,
  ClearAll,
  MailOutline,
  Clear,
  Delete,
  FastForward
} from '@material-ui/icons';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import i18n from '../../i18n';
import RequireScope from '../RequireScope';

import BOOKING_STATUS from '../../constants/employeeBookingStatus';

import '../../assets/stylesheets/ScheduleView.css';

class ActionPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandView: true,
      expandSelectOptions: false,
    };
  }

  handleExpandClick = () => {
    this.setState((prevState) => ({ expandView: !prevState.expandView }));
  };

  handleExpandSelectOptionsClick = () => {
    this.setState((prevState) => ({
      expandSelectOptions: !prevState.expandSelectOptions,
    }));
  };

  render() {
    const { expandView, expandSelectOptions } = this.state;
    const {
      onClickSelectAll,
      includeUnconfirmedEmployees,
      includeEmailSentEmployees,
      includeConfirmedEmployees,
      includeCanceledEmployees,
      includeDeclinedEmployees,
      toggleSelectEmployeeFilter,
      onClickClearSelection,
      onClickSendConfirmationEmail,
      onClickSendReleaseEmail,
      onClickFastTrack,
      onClickRemoveBookings,
      selectAllDate,
      onChangeSelectAllDate,
    } = this.props;

    return (
      <Paper className="blockContainer">
        <div className="blockHeader">
          <h5>{i18n.t('schedule:actionPanel')}</h5>
          <IconButton
            className={expandView ? 'expandView' : ''}
            onClick={this.handleExpandClick}
            aria-expanded={expandView}
            aria-label={i18n.t('schedule:showMore')}
          >
            <ExpandMore color="secondary" />
          </IconButton>
        </div>
        <Collapse in={expandView} timeout="auto">
          <List component="nav" aria-label={i18n.t('schedule:actionPanel')}>
            <ListItem button className="selectAllOn" onClick={onClickSelectAll}>
              <ListItemIcon>
                <SelectAll color="secondary" />
              </ListItemIcon>
              <ListItemText primary={i18n.t('schedule:selectAllOn')} />
              <ListItemSecondaryAction className="selectAllDatePickerContainer">
                <br className="selectAllLineBreak" />
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DatePicker
                    value={selectAllDate}
                    onChange={onChangeSelectAllDate}
                    format="d MMM yyyy"
                  />
                </MuiPickersUtilsProvider>
                <IconButton
                  className={expandSelectOptions ? 'expandView' : ''}
                  onClick={this.handleExpandSelectOptionsClick}
                  aria-expanded={expandSelectOptions}
                  aria-label={i18n.t('schedule:showMore')}
                >
                  <ExpandMore color="secondary" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            <Collapse
              in={expandSelectOptions}
              timeout="auto"
              unmountOnExit
              className="collapseContainer"
            >
              <List component="div" disablePadding>
                <ListItem
                  button
                  className="nestedOptions"
                  onClick={() =>
                    toggleSelectEmployeeFilter(BOOKING_STATUS.DEFAULT)
                  }
                  dense
                >
                  <ListItemIcon>
                    <Checkbox
                      checked={includeUnconfirmedEmployees}
                      tabIndex={-1}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={i18n.t('schedule:includeUnconfirmedEmployees')}
                  />
                </ListItem>
                <ListItem
                  button
                  className="nestedOptions"
                  onClick={() =>
                    toggleSelectEmployeeFilter(BOOKING_STATUS.EMAIL_SENT)
                  }
                  dense
                >
                  <ListItemIcon>
                    <Checkbox
                      checked={includeEmailSentEmployees}
                      tabIndex={-1}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={i18n.t('schedule:includeEmailSentEmployees')}
                  />
                </ListItem>
                <ListItem
                  button
                  className="nestedOptions"
                  onClick={() =>
                    toggleSelectEmployeeFilter(BOOKING_STATUS.EMAIL_CONFIRMED)
                  }
                  dense
                >
                  <ListItemIcon>
                    <Checkbox
                      checked={includeConfirmedEmployees}
                      tabIndex={-1}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={i18n.t('schedule:includeConfirmedEmployees')}
                  />
                </ListItem>
                <ListItem
                  button
                  className="nestedOptions"
                  onClick={() =>
                    toggleSelectEmployeeFilter(BOOKING_STATUS.CANCELED)
                  }
                  dense
                >
                  <ListItemIcon>
                    <Checkbox
                      checked={includeCanceledEmployees}
                      tabIndex={-1}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={i18n.t('schedule:includeCanceledEmployees')}
                  />
                </ListItem>
                <ListItem
                  button
                  className="nestedOptions"
                  onClick={() =>
                    toggleSelectEmployeeFilter(BOOKING_STATUS.DECLINED)
                  }
                  dense
                >
                  <ListItemIcon>
                    <Checkbox
                      checked={includeDeclinedEmployees}
                      tabIndex={-1}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={i18n.t('schedule:includeDeclinedEmployees')}
                  />
                </ListItem>
              </List>
            </Collapse>
            <ListItem button onClick={onClickClearSelection}>
              <ListItemIcon>
                <ClearAll color="secondary" />
              </ListItemIcon>
              <ListItemText primary={i18n.t('schedule:clearAllSelected')} />
            </ListItem>
            <ListItem button onClick={onClickSendConfirmationEmail}>
              <ListItemIcon>
                <MailOutline color="secondary" />
              </ListItemIcon>
              <ListItemText
                primary={i18n.t('schedule:sendConfirmationEmail')}
              />
            </ListItem>
            <ListItem button onClick={onClickSendReleaseEmail}>
              <ListItemIcon>
                <Clear color="secondary" />
              </ListItemIcon>
              <ListItemText primary={i18n.t('schedule:sendReleaseEmail')} />
            </ListItem>
            <RequireScope scopes={['bookings:fast-track']}>
              <ListItem button onClick={onClickFastTrack}>
                <ListItemIcon>
                  <FastForward color="error" />
                </ListItemIcon>
                <ListItemText primary={i18n.t('schedule:fastTrack')} />
              </ListItem>
            </RequireScope>

            <ListItem button onClick={onClickRemoveBookings}>
              <ListItemIcon>
                <Delete color="error" />
              </ListItemIcon>
              <ListItemText primary={i18n.t('schedule:removeUnconfirmed')} />
            </ListItem>
          </List>
        </Collapse>
      </Paper>
    );
  }
}

ActionPanel.propTypes = {
  onClickSelectAll: PropTypes.func.isRequired,
  includeUnconfirmedEmployees: PropTypes.bool.isRequired,
  includeEmailSentEmployees: PropTypes.bool.isRequired,
  includeConfirmedEmployees: PropTypes.bool.isRequired,
  includeCanceledEmployees: PropTypes.bool.isRequired,
  includeDeclinedEmployees: PropTypes.bool.isRequired,
  toggleSelectEmployeeFilter: PropTypes.func.isRequired,
  onClickClearSelection: PropTypes.func.isRequired,
  onClickSendConfirmationEmail: PropTypes.func.isRequired,
  onClickSendReleaseEmail: PropTypes.func.isRequired,
  onClickFastTrack: PropTypes.func.isRequired,
  selectAllDate: PropTypes.instanceOf(Date).isRequired,
  onChangeSelectAllDate: PropTypes.func.isRequired,
  onClickRemoveBookings: PropTypes.func.isRequired,
};

export default ActionPanel;
